import {
  AsyncComponent,
  ConfiguredComponents,
} from '@r-and-a-shared-ui/core-component-config';
import { RenderOn } from '../RenderOn/RenderOn';
import type { PageProps } from './types';

import styles from './Page.module.scss';

export const SubHeader = ({ subheader }: Pick<PageProps, 'subheader'>) => {
  return (
    <RenderOn condition={subheader?.length > 0}>
      <section
        className={styles['subheader']}
        data-testid={'page-subheader'}
      >
        {subheader?.map(x => (
          <AsyncComponent
            kontentItem={x}
            contentType={x.system.type as ConfiguredComponents}
            key={x.system.id}
          />
        ))}
      </section>
    </RenderOn>
  );
};
